module.exports = __webpack_public_path__ + "static/media/8.10970092.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene0/asset/8.png
// module id = 1759
// module chunks = 0